import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Button,
  TextField,
  CardContent,
  Checkbox,
  Typography
} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { useNavigate } from 'react-router-dom';
import { useGet, usePost, usePut } from '../../API/request';
import React, { useEffect, useState } from 'react';
import { BallTriangle } from 'react-loader-spinner';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/core/Alert';
import MasterList from '../Master/MasterList';

const LanguageAdd = () => {
  const navigate = useNavigate();
  const postU = usePost();

  const [submitDisabled, setSubmitDisabled] = useState(false);

  const [values, setValues] = useState({
    languagename: '',
    isMain: false
  });
  const [errors, setErrors] = useState({
    languagename: false
  });

  const [alert, setAlert] = useState({
    txt: '',
    isVisible: false,
    type: 'error'
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    setErrors({
      ...errors,
      [event.target.name]: false
    });
  };

  const checkboxHandle = () => {
    setValues({
      ...values,
      isMain: !values.isMain
    });
  };

  const showAlert = (type, text) => {
    setAlert({
      txt: text,
      type,
      isVisible: true
    });

    setTimeout(() => {
      setAlert({
        txt: text,
        type,
        isVisible: false
      });

      setSubmitDisabled(false);
    }, 1400);
  };

  const validate = () => {
    let validComplete = true;
    let formErrors = { ...errors };
    if (values.languagename === '') {
      validComplete = false;
      formErrors.languagename = false;
      showAlert('error', 'Поле Language name не должно быть пустым');
    }
    setErrors(formErrors);
    return validComplete;
  };

  const clearForm = () => {
    setValues({
      languagename: '',
      isMain: false
    });
  };

  const submit = async () => {
    if (validate()) {
      setSubmitDisabled(true);

      const data = {
        name: values.languagename.toUpperCase(),
        isMain: values.isMain
      };

      postU('languages', data)
        .then((resp) => {
          if (resp.status === 'success') {
            showAlert('success', 'Language added');
            clearForm();
          } else {
            showAlert('error', 'Ошибка');
          }
        })
        .catch((err) => {
          showAlert('error', 'Ошибка сервера');
          setSubmitDisabled(false);
        })
        .finally(() => {});
    }
  };

  return (
    <>
      <Helmet>
        <title>Create new language</title>
      </Helmet>
      <Box sx={{ pt: 2 }}>
        <Container maxWidth={false}>
          <Button startIcon={<ChevronLeft />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: 'background.default', minHeight: '100%' }}>
        <Container maxWidth={false}>
          <Box sx={{ pt: 2 }}>
            <form>
              <Card>
                <CardHeader title="Добавление языка" />
                <Divider />
                <CardContent sx={{ position: 'relative' }}>
                  <Box display={'flex'} alignItems={'center'}>
                    <TextField
                      sx={{ mr: 3 }}
                      label="Language name"
                      margin="normal"
                      name="languagename"
                      onChange={handleChange}
                      type="text"
                      value={values.username}
                      variant="outlined"
                      error={errors.languagename}
                    />
                    <Typography variant="h5" mr={1}>
                      Главный
                    </Typography>
                    <Checkbox
                      checked={values.isMain}
                      size="large"
                      onChange={checkboxHandle}
                    />
                  </Box>

                  <Alert
                    severity={alert.type}
                    style={{ display: alert.isVisible ? 'flex' : 'none' }}
                  >
                    {alert.txt}
                  </Alert>
                </CardContent>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={submit}
                    disabled={submitDisabled}
                  >
                    Добавить
                  </Button>
                </Box>
              </Card>
            </form>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default LanguageAdd;
